import type { ReactNode } from 'react';
import { cn } from './utils/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'rounded-xl border border-dashed border-border-strong bg-surface-muted/40 p-8 sm:p-10 text-center',
        className,
      )}
    >
      {icon ? (
        <div className="mx-auto h-12 w-12 rounded-full bg-surface grid place-items-center text-brand-600">
          {icon}
        </div>
      ) : null}
      <p className="mt-4 font-medium text-fg">{title}</p>
      {description ? (
        <p className="mt-2 text-sm text-fg-muted max-w-md mx-auto">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
